import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  Label,
  UncontrolledTooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  UncontrolledDropdown,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "react-calendar/dist/Calendar.css"; // Import the default calendar styles
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; // Import the styles
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Task = () => {
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [modal, setModal] = useState(false);
  const [modal1, setEditModal] = useState(false);
  const [deleteProjectName, setDeleteProjectName] = useState("");
  const [showTodoDeleteConfirmation, setShowTodoDeleteConfirmation] =
    useState(false);
  const [showProgressDeleteConfirmation, setShowProgressDeleteConfirmation] =
    useState(false);
  const [showCompletedDeleteConfirmation, setShowCompletedDeleteConfirmation] =
    useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const toggleDropdown1 = () => setDropdownOpen1((prevState) => !prevState);
  const toggleDropdown2 = () => setDropdownOpen2((prevState) => !prevState);
  const toggleDropdown3 = () => setDropdownOpen3((prevState) => !prevState);
  const toggleModal = () => {
    setModal((prevState) => !prevState);
    // Reset form when modal is closed
    if (modal) {
      setaddtask({
        projectid: "",
        taskname: "",
        assignto: [], // Reset to empty array
        startdate: "",
        enddate: "",
        description: "",
        image: "",
      });
      setShowAssignDropdown(false);
    }
  };
  const toggleEditModal = () => setEditModal((prevState) => !prevState);

  const [clientForm, setClientForm] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewProgressModal, setViewProgressModal] = useState(false);
  const [viewCompletedModal, setViewCompletedModal] = useState(false);

  // const toggleViewModal = () => setViewModal(prevState => !prevState);

  const [selectedTodoForView, setSelectedTodoForView] = useState(null);
  const [selectedProgressView, setSelectedProgressView] = useState(null);
  const [selectedCompletedView, setSelectedCompletedView] = useState(null);

  const toggleViewModal = (item) => {
    setSelectedTodoForView(item);
    setViewModal((prevState) => !prevState);
  };

  const toggleProgressModal = (prog) => {
    setSelectedProgressView(prog);
    setViewProgressModal((prevState) => !prevState);
  };

  const toggleCompletedModal = (comp) => {
    setSelectedCompletedView(comp);
    setViewCompletedModal((prevState) => !prevState);
  };

  // Function to format the selected date label

  const [progressTodoPercentage, setProgressTodoPercentage] = useState(1);
  const [progressInComPercentage, setProgressInComPercentage] = useState(50);
  const [progressComPercentage, setProgressComPercentage] = useState(100);
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const Employee = ["Jyosh", "Shashi", "Divya", "Harish"];
  const Projects = ["Mine", "AecEarth", "Bim", "Swifter"];
  const Period = ["Week", "Month", "Year"];

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "ongoing", label: "Ongoing" },
    { value: "completed", label: "Completed" },
  ];

  // Fix: Use proper cookie pattern instead of token
  const emp_id = Cookies.get('emp_id');
  const company_id = Cookies.get('company_id');

  // const emp_id = 1;

  const [project, setproject] = useState([]);
  const fetchProjectData = async () => {
    try {
      if (!company_id || !emp_id) {
        throw new Error('Missing company_id or emp_id in cookies');
      }
      const response = await api.get(`viewProjectDetails.php?p_m_id=${emp_id}&company_id=${company_id}`);
      setproject(response.data);
      // console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [task, settask] = useState([]);
  const fetchProjectDataTask = async () => {
    try {
      if (!company_id || !emp_id) {
        throw new Error('Missing company_id or emp_id in cookies');
      }
      const response = await api.get(`viewTask.php?id=${emp_id}&company_id=${company_id}`);
      // Ensure we always have an array
      settask(Array.isArray(response.data) ? response.data : []);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      settask([]); // Set empty array on error
    }
  };

  // Remove duplicate tasks by t_id
  const uniqueTasks = Array.isArray(task)
    ? task.filter((t, i, arr) => arr.findIndex(x => x.t_id === t.t_id) === i)
    : [];
  const todoTasks = uniqueTasks.filter((task) => task.status === "to-do");
  const completedTasks = uniqueTasks.filter((task) => task.status === "completed");
  const progressTasks = uniqueTasks.filter((task) => task.status === "In-Progress");
  // console.log(completedTasks);

  const [employees, setemployees] = useState();
  const fetchEmployeeData = async () => {
    try {
      if (!company_id) {
        throw new Error('Missing company_id in cookies');
      }
      const response = await api.get(`employeesView.php?company_id=${company_id}`);
      setemployees(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchProjectData();
    fetchEmployeeData();
    fetchProjectDataTask();
  }, []);

  const [filterChoose, setfilterChoose] = useState({
    emp_id: emp_id,
    assign_to: "",
    p_id: "",
    period: "",
  });

  const fetchData = async () => {
    try {
      if (!company_id || !emp_id) {
        throw new Error('Missing company_id or emp_id in cookies');
      }
      // If no filters are selected, show all tasks
      if (!filterChoose.assign_to && !filterChoose.p_id && !filterChoose.period) {
        const response = await api.get(`viewTask.php?id=${emp_id}&company_id=${company_id}`);
        settask(Array.isArray(response.data) ? response.data : []);
        console.log('All tasks:', response.data);
      } else {
        // Otherwise, show filtered tasks
        const filterToSend = {
          emp_id: emp_id || "",
          assign_to: filterChoose.assign_to || "",
          p_id: filterChoose.p_id || "",
          period: filterChoose.period || "",
          company_id: company_id || ""
        };
        console.log('Sending filterToSend:', filterToSend);
        const response = await api.post(`filterchoose.php`, filterToSend);
        console.log('Received response:', response.data);
        settask(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEmployeeSelect = async (employee) => {
    setSelectedEmployee(employee.emp_name);
    setfilterChoose((prevState) => ({
      ...prevState,
      assign_to: employee.emp_id,
    }));
  };

  const handleProjectSelect = (project) => {
    setSelectedProject(project.p_name);
    setfilterChoose((prevState) => ({
      ...prevState,
      p_id: project.p_id,
    }));
  };

  const handlePeriodSelect = (period) => {
    setSelectedPeriod(period);
    setfilterChoose((prevState) => ({
      ...prevState,
      period: period,
    }));
  };

  useEffect(() => {
    fetchData();
  }, [filterChoose.assign_to, filterChoose.period, filterChoose.p_id]);

  const [todoIdForDelete, setTodoIdForDelete] = useState(null);
  const [selectedItemIdForDelete, setSelectedItemIdForDelete] = useState(null);
  const [completedIdForDelete, setCompletedIdForDelete] = useState(null);

  const handleDeleteConfirmation = async (t_id) => {
    const fetchData = async () => {
      try {
        const response = await api.delete(`deleteTask.php?id=${t_id}&company_id=${company_id}`);
        console.log(response.data);
        await fetchProjectDataTask();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  };

  const handleProgressDeleteConfirmation = async (t_id) => {
    const fetchData = async () => {
      try {
        const response = await api.delete(`deleteTask.php?id=${t_id}&company_id=${company_id}`);
        console.log(response.data);
        await fetchProjectDataTask();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  };

  const handleCompletedDeleteConfirmation = async (t_id) => {
    const fetchData = async () => {
      try {
        const response = await api.delete(`deleteTask.php?id=${t_id}&company_id=${company_id}`);
        console.log(response.data);
        await fetchProjectDataTask();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  };

  const [addtask, setaddtask] = useState({
    projectid: "",
    taskname: "",
    assignto: [], // Changed to array for multi-select
    startdate: "",
    enddate: "",
    description: "",
    image: "",
  });

  const [showAssignDropdown, setShowAssignDropdown] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "assignto") {
      // Handle multi-select for assign to field
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setaddtask((prevState) => ({
        ...prevState,
        [name]: selectedOptions,
      }));
    } else {
      setaddtask((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    console.log(addtask);
  };

  const handleMultiSelectEmployee = (employeeId, employeeName) => {
    setaddtask((prevState) => {
      const currentSelected = [...prevState.assignto];
      const employeeIdStr = employeeId.toString();
      
      if (currentSelected.includes(employeeIdStr)) {
        // Remove if already selected
        return {
          ...prevState,
          assignto: currentSelected.filter(id => id !== employeeIdStr)
        };
      } else {
        // Add if not selected
        return {
          ...prevState,
          assignto: [...currentSelected, employeeIdStr]
        };
      }
    });
  };

  const getSelectedEmployeeNames = () => {
    if (!employees || !Array.isArray(employees)) return "Select Assign To";
    
    const selectedNames = addtask.assignto.map(id => {
      const employee = employees.find(emp => emp.emp_id.toString() === id);
      return employee ? employee.emp_name : '';
    }).filter(name => name !== '');
    
    return selectedNames.length > 0 ? selectedNames.join(', ') : "Select Assign To";
  };

  const isEmployeeSelected = (employeeId) => {
    return addtask.assignto.includes(employeeId.toString());
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAssignDropdown && !event.target.closest('.assign-dropdown-container')) {
        setShowAssignDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAssignDropdown]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setaddtask((prevState) => ({
      ...prevState,
      image: file,
    }));
  };

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!company_id || !emp_id) {
      console.error('Missing company_id or emp_id in cookies');
      return;
    }

    // Validate that at least one employee is selected
    if (addtask.assignto.length === 0) {
      alert('Please select at least one employee to assign the task to.');
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("emp_id", emp_id);
    formDataToSend.append("company_id", company_id);
    formDataToSend.append("projectid", addtask.projectid);
    formDataToSend.append("taskname", addtask.taskname);
    formDataToSend.append("assignto", addtask.assignto.join(',')); // Join array with commas
    formDataToSend.append("startdate", addtask.startdate);
    formDataToSend.append("enddate", addtask.enddate);
    formDataToSend.append("description", addtask.description);
    formDataToSend.append("uploadimage", addtask.image);

    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post(`addTask.php?company_id=${company_id}&emp_id=${emp_id}`, formDataToSend);
      console.log("Data sent successfully:", response.data);
      
      // Show success message and close modal
      setSuccessMessage('Task added successfully!');
      setShowSuccessAlert(true);
      setModal(false);
      
      // Reset form with array
      setaddtask({
        projectid: "",
        taskname: "",
        assignto: [], // Reset to empty array
        startdate: "",
        enddate: "",
        description: "",
        image: "",
      });
      setShowAssignDropdown(false); // Close dropdown
      
      // Refresh task data
      await fetchProjectDataTask();
      
      // Hide success alert after 3 seconds
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);
      
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const getImagePath = (imageName) => {
    if (!imageName) return '/images/default-profile.png';
    try {
      const decodedImageName = decodeURIComponent(imageName);
      return `/images/${decodedImageName}`;
    } catch (error) {
      return '/images/default-profile.png';
    }
  };

  // Add this function for status change
  const handleStatusChange = async (t_id, newStatus) => {
    try {
      await api.post(`updateTaskStatus.php`, { t_id, status: newStatus });
      fetchProjectDataTask();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row>
            {/* ... Your existing code ... */}

            {/* Total Projects Card */}
            <Col lg="12" xl="12">
              <Card className="card-start " style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardBody>
                  <div className=" mb-3 ">
                    <h2 className="mr-3">Your Task </h2>
                    <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">
                      <div className="text-lg-end">
                        <Dropdown
                          className="mb-2"
                          isOpen={dropdownOpen1}
                          toggle={toggleDropdown1}
                        >
                          <DropdownToggle caret>
                            {selectedEmployee
                              ? selectedEmployee
                              : "Select Employee"}
                          </DropdownToggle>
                          <DropdownMenu left>
                            {Array.isArray(employees) ? (
                              employees.map((employeeItem, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={() =>
                                    handleEmployeeSelect(employeeItem)
                                  }
                                >
                                  {employeeItem.emp_name}{" "}
                                  {/* Render specific property of employee object */}
                                </DropdownItem>
                              ))
                            ) : (
                              <p>No employees available</p>
                            )}
                          </DropdownMenu>
                        </Dropdown>
                        <Dropdown
                          className="mb-2"
                          isOpen={dropdownOpen2}
                          toggle={toggleDropdown2}
                        >
                          <DropdownToggle caret>
                            {selectedProject
                              ? selectedProject
                              : "Select Project"}
                          </DropdownToggle>
                          <DropdownMenu left>
                            {Array.isArray(project) ? (
                              project.map((projectItem, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={() =>
                                    handleProjectSelect(projectItem)
                                  }
                                >
                                  {projectItem.p_name}{" "}
                                  {/* Render specific property of project object */}
                                </DropdownItem>
                              ))
                            ) : (
                              <p>No projects available</p>
                            )}
                          </DropdownMenu>
                        </Dropdown>
                        <Dropdown
                          className="mb-2"
                          isOpen={dropdownOpen3}
                          toggle={toggleDropdown3}
                        >
                          <DropdownToggle caret>
                            {selectedPeriod ? selectedPeriod : "Select Period"}
                          </DropdownToggle>
                          <DropdownMenu left>
                            {Period.map((period, index) => (
                              <DropdownItem
                                key={index}
                                onClick={() => handlePeriodSelect(period)}
                              >
                                {period}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                        <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={toggleModal}>
                          Add Task
                        </Button>
                      </div>
                      
                    </div>

                    <div>
                      <Modal isOpen={modal} toggle={toggleModal}>
                        <Form
                          onSubmit={handleSubmit}
                          enctype="multipart/form-data"
                        >
                          <ModalHeader toggle={toggleModal}>
                            Add Task
                          </ModalHeader>
                          <Row className="px-3">
                            <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-status"
                                >
                                  Project Name<span style={{color: 'red'}}> *</span>  
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-status"
                                  type="select"
                                  name="projectid"
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Select Project</option>
                                  {project &&
                                    Array.isArray(project) &&
                                    project.map((option) => (
                                      <option
                                        key={option.p_id}
                                        value={option.p_id}
                                      >
                                        {option.p_name}
                                      </option>
                                    ))}
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-name"
                                >
                                  Task Name<span style={{color: 'red'}}> *</span> 
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-name"
                                  type="text"
                                  name="taskname"
                                  onChange={handleInputChange}
                                  placeholder="Task Name"
                                  required
                                />
                              </FormGroup>
                            </Col>

                            <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-manager"
                                >
                                  {" "}
                                  Assign To<span style={{color: 'red'}}> *</span> 
                                </label>
                                <div className="assign-dropdown-container" style={{ position: 'relative' }}>
                                  <div
                                    className="form-control-alternative"
                                    style={{
                                      cursor: 'pointer',
                                      minHeight: '38px',
                                      padding: '8px 12px',
                                      border: '1px solid #d1d3e2',
                                      borderRadius: '0.375rem',
                                      backgroundColor: '#fff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                    onClick={() => setShowAssignDropdown(!showAssignDropdown)}
                                  >
                                    <span style={{ 
                                      color: addtask.assignto.length > 0 ? '#333' : '#6c757d',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap'
                                    }}>
                                      {getSelectedEmployeeNames()}
                                    </span>
                                    <i className={`fas fa-chevron-${showAssignDropdown ? 'up' : 'down'}`}></i>
                                  </div>
                                  
                                  {showAssignDropdown && (
                                    <div style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: '#fff',
                                      border: '1px solid #d1d3e2',
                                      borderRadius: '0.375rem',
                                      boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                      zIndex: 1000,
                                      maxHeight: '200px',
                                      overflowY: 'auto'
                                    }}>
                                      {employees && Array.isArray(employees) && employees.map((employee) => (
                                        <div
                                          key={employee.emp_id}
                                          style={{
                                            padding: '8px 12px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderBottom: '1px solid #f8f9fa'
                                          }}
                                          onClick={() => handleMultiSelectEmployee(employee.emp_id, employee.emp_name)}
                                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                          onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={isEmployeeSelected(employee.emp_id)}
                                            onChange={() => {}} // Handle change in onClick
                                            style={{ marginRight: '8px' }}
                                          />
                                          <span>{employee.emp_name}</span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                                {addtask.assignto.length === 0 && (
                                  <small style={{ color: 'red' }}>Please select at least one employee</small>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-starting"
                                >
                                  Task Starting Date<span style={{color: 'red'}}> *</span> 
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-starting"
                                  type="datetime-local"
                                  name="startdate"
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-ending"
                                >
                                  Task Ending Date<span style={{color: 'red'}}> *</span> 
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-ending"
                                  type="datetime-local"
                                  name="enddate"
                                  onChange={handleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-description"
                                >
                                  Project Description
                                </label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={addtask.description}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setaddtask((prevState) => ({
                                      ...prevState,
                                      description: data,
                                    }));
                                  }}
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-file"
                                >
                                  Upload File
                                </label>
                                <Input
                                  type="file"
                                  className="form-control-file"
                                  id="input-file"
                                  name="image"
                                  onChange={handleFileChange}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="12" className="text-center mb-2 ">
                              <Button
                                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                                type="submit"
                                className="bg-slate-500 text-white"
                              >
                                Submit
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </Modal>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg="4">
              <Card className="card-stats mb-4 mb-xl-0 m-0 " style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardBody className="text-center">
                  <Row>
                    <i className="fas fa-clipboard-list" style={{ color: '#000', fontSize: '22px', marginRight: '10px' }}></i>
                    <h2 className="ml-2">To Do</h2>
                    <i
                      className="fa-solid fa-circle-right ml-2 mr-2 mt-1"
                      style={{ color: "#ED6F07", fontSize: "20px" }}
                    ></i>
                    <h2> ({todoTasks.length})</h2>
                  </Row>
                </CardBody>
              </Card>
              {[...todoTasks].reverse().map((item) => {
                return (
                  <>
                    <Card key={item} className="card-stats mb-4 mb-xl-0  mt-3 gap-" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                      <CardBody>
                        <Row>
                          <Col xs="3" className="text-center mr-3">
                            <div style={{ width: "60px", height: "60px" }}>
                              <CircularProgressbar
                                value={progressTodoPercentage}
                                text={`${progressTodoPercentage}%`}
                                styles={buildStyles({
                                  textColor: "#ED6F07",

                                  pathColor: "orange",
                                  trailColor: "#eee",
                                })}
                              />
                            </div>
                            <div></div>
                          </Col>

                          <Col className="text-left ml-3">
                            <h3>{item.taskname} </h3>
                            {item.end_date}
                            <Col className="d-flex justify-content-left ">
                              <div className="avatar-group style={{height:'40px', width:'25px'}}">
                                <a
                                  className="avatar avatar-sm"
                                  href="#pablo"
                                  id={"tooltip_" + item.t_id}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    className="rounded-circle"
                                    style={{ height: "35px", width: "35px" }}
                                    src={getImagePath(item.emp_profile_image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = '/images/default-profile.png';
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={"tooltip_" + item.t_id}
                                >
                                  {item.emp_name}
                                </UncontrolledTooltip>
                                <a
                                  className="avatar avatar-sm"
                                  href="#pablo"
                                  id={"tooltip2" + item.t_id}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    className="rounded-circle"
                                    style={{ height: "35px", width: "35px" }}
                                    src={getImagePath(item.assign_to_profile_image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = '/images/default-profile.png';
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={"tooltip2" + item.t_id}
                                >
                                  {item.assign_to_name}
                                </UncontrolledTooltip>
                              </div>
                            </Col>
                          </Col>
                          <span>
                            <UncontrolledDropdown className="">
                              <DropdownToggle
                                caret
                                color="link"
                                onClick={toggleDropdown}
                                className="p-0"
                              >
                                <i className="fas fa-ellipsis-v"></i>
                              </DropdownToggle>
                              <DropdownMenu right>
                                {item &&
                                  (item.emp_id === emp_id ? (
                                    <>
                                      <Link
                                        to={`/project-admin/project-management/Viewtask/${item.t_id}`}
                                        style={{ color: "black" }}
                                      >
                                        <DropdownItem onClick={toggleEditModal}>
                                          View
                                        </DropdownItem>
                                      </Link>
                                      <Link
                                        to={`/project-admin/project-management/edittask/${item.t_id}`}
                                        style={{ color: "black" }}
                                      >
                                        <DropdownItem onClick={toggleEditModal}>
                                          Edit
                                        </DropdownItem>
                                      </Link>
                                      <DropdownItem
                                        onClick={() => {
                                          setShowTodoDeleteConfirmation(true);
                                          setTodoIdForDelete(item.t_id);
                                        }}
                                      >
                                        Delete
                                      </DropdownItem>
                                    </>
                                  ) : (
                                    <>
                                      <Link
                                        to={`/project-admin/project-management/Viewtask/${item.t_id}`}
                                        style={{ color: "black" }}
                                      >
                                        <DropdownItem onClick={toggleEditModal}>
                                          View
                                        </DropdownItem>
                                      </Link>
                                    </>
                                  ))}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </span>

                          <Modal isOpen={viewModal} toggle={toggleViewModal}>
                            <ModalHeader toggle={toggleViewModal}>
                              View Task
                            </ModalHeader>
                            <ModalBody>
                              {selectedTodoForView && (
                                <>
                                  <h3 for="exampleField">Project Name:</h3>
                                  <h3>
                                    Task Name: {selectedTodoForView.taskname}
                                  </h3>
                                  <h3>
                                    Assign By: {selectedTodoForView.emp_name}
                                  </h3>
                                  <h3>
                                    Assign To:{" "}
                                    {selectedTodoForView.assign_to_name}
                                  </h3>
                                  <h3>
                                    Start Date: {selectedTodoForView.start_date}
                                  </h3>
                                  <h3>
                                    End Date: {selectedTodoForView.end_date}
                                  </h3>
                                  <h3>
                                    Description:{" "}
                                    {selectedTodoForView.t_description}
                                  </h3>
                                  {/* Add other task details */}
                                </>
                              )}
                            </ModalBody>
                            <ModalFooter>
                              <Button
                                onClick={() => toggleViewModal(null)}
                                className="btn btn-primary"
                              >
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </Row>
                      </CardBody>
                    </Card>
                    <Modal
                      isOpen={showTodoDeleteConfirmation}
                      toggle={() => setShowTodoDeleteConfirmation(false)}
                    >
                      <ModalHeader>Confirm Deletion</ModalHeader>
                      <ModalBody>
                        <p>
                          Are you sure you want to delete this task ?
                        </p>
                      </ModalBody>
                      <div className="modal-footer">
                        <Button
                          color="danger"
                          onClick={() => {
                            setShowTodoDeleteConfirmation(false);
                            handleDeleteConfirmation(todoIdForDelete);
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          color="secondary"
                          onClick={() => setShowTodoDeleteConfirmation(false)}
                        >
                          No
                        </Button>
                      </div>
                    </Modal>
                  </>
                );
              })}
            </Col>
            <Col lg="4">
              <Card className="card-stats mb-4 mb-xl-0 m-0" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardBody>
                  <Row>
                    <i className="fas fa-spinner" style={{ color: '#000', fontSize: '22px', marginRight: '10px' }}></i>
                    <h2 className="ml-2">In Progress</h2>
                    <i
                      className="fa-solid fa-circle-right ml-2 mr-2 mt-1"
                      style={{ color: "#ED6F07", fontSize: "20px" }}
                    ></i>
                    <h2> ({progressTasks.length})</h2>
                  </Row>
                </CardBody>
              </Card>

              {[...progressTasks].reverse().map((prog) => {
                return (
                  <>
                    <Card className="card-stats mb-4 mb-xl-0  mt-3" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                      <CardBody>
                        <Row>
                          <Col xs="3" className="text-center mr-3">
                            <div style={{ width: "60px", height: "60px" }}>
                              <CircularProgressbar
                                value={progressInComPercentage}
                                text={`${progressInComPercentage}%`}
                                styles={buildStyles({
                                  textColor: "blue",

                                  pathColor: "#007bff",
                                  trailColor: "#eee",
                                })}
                              />
                            </div>
                            <div></div>
                          </Col>

                          <Col className="text-left ml-3">
                            <h3>{prog.taskname} </h3>
                            {prog.end_date}
                            <Col className="d-flex justify-content-left ">
                              <div className="avatar-group style={{height:'40px', width:'25px'}}">
                                <a
                                  className="avatar avatar-sm"
                                  href="#pablo"
                                  id={"tooltip1" + prog.t_id}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    className="rounded-circle"
                                    style={{height:'35px', width:'35px'}}
                                    src={getImagePath(prog.emp_profile_image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = '/images/default-profile.png';
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={"tooltip1" + prog.t_id}
                                >
                                  {prog.emp_name}
                                </UncontrolledTooltip>
                                <a
                                  className="avatar avatar-sm"
                                  href="#pablo"
                                  id={"tooltip2" + prog.t_id}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    className="rounded-circle"
                                    style={{height:'35px', width:'35px'}}
                                    src={getImagePath(prog.assign_to_profile_image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = '/images/default-profile.png';
                                    }}
                                  />
                                </a>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={"tooltip2" + prog.t_id}
                                >
                                  {prog.assign_to_name}
                                </UncontrolledTooltip>
                              </div>
                            </Col>
                          </Col>

                          <span>
                            <UncontrolledDropdown className="">
                              <DropdownToggle
                                caret
                                color="link"
                                onClick={toggleDropdown}
                                className="p-0"
                              >
                                <i className="fas fa-ellipsis-v"></i>
                              </DropdownToggle>
                              <DropdownMenu right>
                              <Link
                                        to={`/project-admin/project-management/Viewtask/${prog.t_id}`}
                                        style={{ color: "black" }}
                                      >
                                        <DropdownItem onClick={toggleEditModal}>
                                          View
                                        </DropdownItem>
                                      </Link>

                                <Link
                                  to={`/project-admin/project-management/edittask/${prog.t_id}`}
                                  style={{ color: "black" }}
                                >
                                  <DropdownItem onClick={toggleEditModal}>
                                    Edit
                                  </DropdownItem>
                                </Link>
                                {/* <DropdownItem onClick={() => { setShowProgressDeleteConfirmation(prog.t_id); }}>Delete</DropdownItem> */}
                                <DropdownItem
                                  onClick={() => {
                                    setSelectedItemIdForDelete(prog.t_id);
                                    setShowProgressDeleteConfirmation(true);
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </span>

                          <Modal
                            isOpen={viewProgressModal}
                            toggle={toggleProgressModal}
                          >
                            <ModalHeader toggle={toggleProgressModal}>
                              View Task
                            </ModalHeader>
                            <ModalBody>
                              {selectedProgressView && (
                                <>
                                  <h3 for="exampleField">Project Name:</h3>
                                  <h3>
                                    Task Name: {selectedProgressView.taskname}
                                  </h3>
                                  <h3>
                                    Assign By: {selectedProgressView.emp_name}
                                  </h3>
                                  <h3>
                                    Assign To:{" "}
                                    {selectedProgressView.assign_to_name}
                                  </h3>
                                  <h3>
                                    Start Date:{" "}
                                    {selectedProgressView.start_date}
                                  </h3>
                                  <h3>
                                    End Date: {selectedProgressView.end_date}
                                  </h3>
                                  <h3>
                                    Description:{" "}
                                    {selectedProgressView.t_description}
                                  </h3>
                                  {/* Add other task details */}
                                </>
                              )}
                            </ModalBody>
                            <ModalFooter>
                              <Button
                                onClick={() => toggleProgressModal(null)}
                                className="btn btn-primary"
                              >
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </Row>
                      </CardBody>
                    </Card>

                    <Modal
                      isOpen={showProgressDeleteConfirmation}
                      toggle={() => setShowProgressDeleteConfirmation(false)}
                    >
                      <ModalHeader>Confirm Deletion</ModalHeader>
                      <ModalBody>
                        Are you sure you want to delete this task?
                      </ModalBody>
                      <div className="modal-footer">
                        {/* <Button color="danger" onClick={() => { setShowProgressDeleteConfirmation(false); handleProgressDeleteConfirmation(prog.t_id) }}>Yes</Button> */}
                        <Button
                          color="danger"
                          onClick={() => {
                            setShowProgressDeleteConfirmation(false);
                            handleProgressDeleteConfirmation(
                              selectedItemIdForDelete
                            );
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          color="secondary"
                          onClick={() =>
                            setShowProgressDeleteConfirmation(false)
                          }
                        >
                          No
                        </Button>
                      </div>
                    </Modal>
                  </>
                );
              })}
            </Col>
            <Col lg="4">
              <Card className="card-stats mb-4 mb-xl-0 m-0" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardBody>
                  <Row>
                    <i className="fas fa-check-circle" style={{ color: '#000', fontSize: '22px', marginRight: '10px' }}></i>
                    <h2 className="ml-2">Completed</h2>
                    <i
                      className="fa-solid fa-circle-right ml-2 mr-2 mt-1"
                      style={{ color: "#68D241", fontSize: "20px" }}
                    ></i>
                    <h2> ({completedTasks.length})</h2>
                  </Row>
                </CardBody>
              </Card>

              {[...completedTasks].reverse().map((comp) => {
                return (
                  <>
                    <div>
                      <Card className="card-stats mb-4 mb-xl-0  mt-3" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                        <CardBody>
                          <Row>
                            <Col xs="3" className="text-center mr-3">
                              <div style={{ width: "60px", height: "60px" }}>
                                <CircularProgressbar
                                  value={progressComPercentage}
                                  text={`${progressComPercentage}%`}
                                  styles={buildStyles({
                                    textColor: "green",

                                    pathColor: "#68D241",
                                    trailColor: "#eee",
                                  })}
                                />
                              </div>
                              <div></div>
                            </Col>

                            <Col className="text-left ml-3">
                              <h3>{comp.taskname}</h3>
                              {comp.end_date}
                              <Col className="d-flex justify-content-left ">
                                <div className="avatar-group style={{height:'40px', width:'25px'}}">
                                  <a
                                    className="avatar avatar-sm"
                                    href="#pablo"
                                    id={"tooltip1" + comp.t_id}
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <img
                                      alt="..."
                                      className="rounded-circle"
                                      style={{height:'35px', width:'35px'}}
                                      src={getImagePath(comp.emp_profile_image)}
                                      onError={e => {
                                        e.target.onerror = null;
                                        e.target.src = '/images/default-profile.png';
                                      }}
                                    />
                                  </a>
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={"tooltip1" + comp.t_id}
                                  >
                                    {comp.emp_name}
                                  </UncontrolledTooltip>
                                  <a
                                    className="avatar avatar-sm"
                                    href="#pablo"
                                    id={"tooltip2" + comp.t_id}
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <img
                                      alt="..."
                                      className="rounded-circle"
                                      style={{height:'35px', width:'35px'}}
                                      src={getImagePath(comp.assign_to_profile_image)}
                                      onError={e => {
                                        e.target.onerror = null;
                                        e.target.src = '/images/default-profile.png';
                                      }}
                                    />
                                  </a>
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={"tooltip2" + comp.t_id}
                                  >
                                    {comp.assign_to_name}
                                  </UncontrolledTooltip>
                                </div>
                              </Col>
                            </Col>
                            <span>
                              <UncontrolledDropdown className="">
                                <DropdownToggle
                                  caret
                                  color="link"
                                  onClick={toggleDropdown}
                                  className="p-0"
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  {/* <DropdownItem onClick={toggleViewModal}>View</DropdownItem> */}

                                  <Link
                                        to={`/project-admin/project-management/Viewtask/${comp.t_id}`}
                                        style={{ color: "black" }}
                                      >
                                        <DropdownItem onClick={toggleEditModal}>
                                          View
                                        </DropdownItem>
                                      </Link>

                                  <Link
                                    to={`/project-admin/project-management/edittask/${comp.t_id}`}
                                    style={{ color: "black" }}
                                  >
                                    <DropdownItem onClick={toggleEditModal}>
                                      Edit
                                    </DropdownItem>
                                  </Link>
                                  <DropdownItem
                                    onClick={() => {
                                      setCompletedIdForDelete(comp.t_id);
                                      setShowCompletedDeleteConfirmation(true);
                                    }}
                                  >
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </span>

                            <Modal
                              isOpen={viewCompletedModal}
                              toggle={toggleCompletedModal}
                            >
                              <ModalHeader toggle={toggleCompletedModal}>
                                View Task
                              </ModalHeader>
                              <ModalBody>
                                {selectedCompletedView && (
                                  <>
                                    <h3 for="exampleField">Project Name:</h3>
                                    <h3>
                                      Task Name:{" "}
                                      {selectedCompletedView.taskname}
                                    </h3>
                                    <h3>
                                      Assign By:{" "}
                                      {selectedCompletedView.emp_name}
                                    </h3>
                                    <h3>
                                      Assign To:{" "}
                                      {selectedCompletedView.assign_to_name}
                                    </h3>
                                    <h3>
                                      Start Date:{" "}
                                      {selectedCompletedView.start_date}
                                    </h3>
                                    <h3>
                                      End Date: {selectedCompletedView.end_date}
                                    </h3>
                                    <h3>
                                      Description:{" "}
                                      {selectedCompletedView.t_description}
                                    </h3>
                                    {/* Add other task details */}
                                  </>
                                )}
                              </ModalBody>
                              <ModalFooter>
                                <Button
                                  onClick={() => toggleCompletedModal(null)}
                                  className="btn btn-primary"
                                >
                                  Close
                                </Button>
                              </ModalFooter>
                            </Modal>
                          </Row>
                        </CardBody>
                      </Card>

                      <Modal
                        isOpen={showCompletedDeleteConfirmation}
                        toggle={() => setShowCompletedDeleteConfirmation(false)}
                      >
                        <ModalHeader>Confirm Deletion</ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this task?
                        </ModalBody>
                        <div className="modal-footer">
                          <Button
                            color="danger"
                            onClick={() => {
                              setShowCompletedDeleteConfirmation(false);
                              handleCompletedDeleteConfirmation(
                                completedIdForDelete
                              );
                            }}
                          >
                            Yes
                          </Button>
                          <Button
                            color="secondary"
                            onClick={() =>
                              setShowCompletedDeleteConfirmation(false)
                            }
                          >
                            No
                          </Button>
                        </div>
                      </Modal>
                    </div>
                  </>
                );
              })}
            </Col>
          </Row>
        </Container>
      </div>
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => setShowSuccessAlert(false)}
            >OK</Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Task;